// Effect scheduling: queue effects with `delayTicks > 0` and drain them when
// their fire tick arrives. ADR 0009 §2.6.
//
// Drain runs at the very start of `step()` (before maintenance / AI / combat)
// so a delayed effect lands in the same tick as the AI / movement / combat
// pass that would otherwise see its consequences.
import { applyEffect as runEffect } from '../effects.js';
/** Push a fully-formed ScheduledEffect onto the queue. */
export function enqueueEffect(state, sched) {
    state.scheduledEffects.push(sched);
}
/**
 * Pop every ScheduledEffect with `fireAt <= state.tick` and re-resolve it.
 * Mutates `state.scheduledEffects` (replaces the array with the surviving
 * future-dated entries so the relative ordering is preserved).
 */
export function drainDueEffects(state) {
    if (state.scheduledEffects.length === 0)
        return;
    const tick = state.tick;
    const remaining = [];
    for (const sched of state.scheduledEffects) {
        if (sched.fireAt > tick) {
            remaining.push(sched);
            continue;
        }
        const caster = state.entities.find((e) => e.id === sched.casterId);
        if (caster === undefined || caster.hp <= 0)
            continue;
        const original = sched.primaryTargetId !== null
            ? (state.entities.find((e) => e.id === sched.primaryTargetId) ?? null)
            : null;
        let resolvedTarget;
        if (original !== null && original.hp > 0) {
            resolvedTarget = original;
        }
        else if (sched.fallbackPolicy === 'self') {
            resolvedTarget = caster;
        }
        else {
            continue; // skip
        }
        runEffect(sched.effect, caster, resolvedTarget, state, sched.skillId, sched.effectAmountMod ?? 1, sched.itemSkillValue, sched.permanentBuffs ?? false);
    }
    state.scheduledEffects = remaining;
}
//# sourceMappingURL=scheduling.js.map